import { environment } from 'environments/environment'

/**
 * Load the source for Security Details WebComponent, which is used in the Security Details panel
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadSecurityDetailsScript(document: Document) {
  const now = Date.now()
  const jsPath = environment.externalComponents.securityDetail
  const script = document.getElementById('securityDetailUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
